import { useSSRSafeId } from "@react-aria/ssr";
import clsx from "clsx";
import { useFormik } from "formik";
import React, { useState } from "react";
import { InputNumerico } from "../inputs/InputNumerico";
const estiloEditarPrecoTinta = require("./editarPrecoTinta.module.scss").default;
const estiloRelatorioVertical = require('../../estilos/relatorioVertical.module.scss').default
const estiloTabela = require('../../estilos/tabelas.module.scss').default

export type EditarPrecoTintaProps = {
    dadosTinta: DadosTinta;
    somenteLeitura?: boolean
    produtoUsaCodigoOuReferencia: string;
    onAplicar: (PrecoTintaNovo: number) => void;
};

export type DadosTinta = {
    nomeProduto: string;
    corProduto: string;
    precoUnitarioProduto: number;
    corantes: DadosCorante[];
}

export type DadosCorante = {
    CodigoProduto?: string;
    Referencia?: string,
    DescricaoProduto?: string;
    Quantidade?: number;
}

export const EditarPrecoTinta = (props: EditarPrecoTintaProps) => {

    const [precoUnitario, setPrecoUnitario] = useState<number>(props.dadosTinta.precoUnitarioProduto);

    const formik = useFormik({
        initialValues: { ...props.dadosTinta },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,
    });

    const dadosProduto = <div style={{ gridTemplateColumns: "192px auto" }} 
            className={clsx(estiloRelatorioVertical.container)}
            id="EditarPrecoTinta_DadosProduto"
        >
        <span className={estiloRelatorioVertical.cabecalho}>Produto</span>
        <span className={clsx(estiloRelatorioVertical.dado, estiloEditarPrecoTinta.whiteLabel, "_w-5/5 ")}><b>{props.dadosTinta.nomeProduto}</b></span>
        <span className={estiloRelatorioVertical.cabecalho}>Cor</span>
        <span className={estiloRelatorioVertical.dado}>{props.dadosTinta.corProduto}</span>
        <span className={estiloRelatorioVertical.cabecalho}>Preço Unitário</span>

        <InputNumerico
            onValorModificado={(valor) => {
                onChangePrecoUnitario(valor)
            }}
            disabled={props.somenteLeitura != null && props.somenteLeitura }
            numeroCasasDecimais={2}
            selecionaValorOnFocus={true}
            campoNullavel={true}
            id="EditarPrecoTinta_precoUnitarioProduto"
            valor={precoUnitario}
            style={{
                maxWidth: "150px",
                width: "35%",
                marginLeft: "6px"
            }}
        />
    </div>

    const onChangePrecoUnitario = (preco: number) => {
        if (isNaN(preco)) {
            formik.setFieldValue("precoUnitarioProduto", props.dadosTinta.precoUnitarioProduto);
            setPrecoUnitario(props.dadosTinta.precoUnitarioProduto);
        }
        else {
            formik.setFieldValue("precoUnitarioProduto", preco);
        }
    }

    const tabelaEditarPrecoTinta =
        <table className={clsx(estiloTabela.tabela, estiloEditarPrecoTinta.larguracemporcento)}
            id="EditarPrecoTinta_tabelaCorantes"
        >
            <thead>
                <tr
                    id="EditarPrecoTinta_tabelaCorantes_linhaCabeçalho"
                >
                    <th style={{ textAlign: "left" }}>
                        {props.produtoUsaCodigoOuReferencia}
                    </th>
                    <th style={{ textAlign: "left" }}>
                        Nome do Corante
                    </th>
                    <th style={{ textAlign: "right" }}>
                        Quantidade
                    </th>
                </tr>
            </thead>
            <tbody
                id="EditarPrecoTinta_Corpo"
            >
                {props.dadosTinta.corantes?.map((corante) => (
                    <tr className={estiloTabela.linhaClicavel}
                        key={`EditarPrecoTinta_tabelaCorantes_linhaCorpo_${corante.CodigoProduto}`}
                        id={`EditarPrecoTinta_tabelaCorantes_linhaCorpo_${corante.CodigoProduto}`}
                    >
                        <td>{corante.CodigoProduto}</td>
                        <td>{corante.DescricaoProduto}</td>
                        <td style={{ textAlign: "right" }}>{corante.Quantidade.toFixed(3).replace(".", ",")}</td>

                    </tr>
                ))}
            </tbody>
        </table>


    const botaoAplicar = <button
        className={`no-global-button ${estiloEditarPrecoTinta.buttonAplicarPreco}`}
        id="EditarPrecoTinta_BotaoAplicar"
        onClick={() => {
            if (isNaN(formik.values.precoUnitarioProduto)) {
                formik.setFieldValue("precoUnitarioProduto", props.dadosTinta.precoUnitarioProduto);
                setPrecoUnitario(props.dadosTinta.precoUnitarioProduto);
            }
            props.onAplicar(formik.values.precoUnitarioProduto)
        }}
    >
        Aplicar
    </button>

    return (
        <>
            {dadosProduto}

            <br />

            {tabelaEditarPrecoTinta}

            {props.somenteLeitura == null || !props.somenteLeitura  && botaoAplicar}
        </>

    );
}